<template>
    <div>
        <ValidationObserver ref="formModalValidate">
            <b-row>
                <b-col cols="12">
                    <b-form-group :label="$t('name')">
                        <ValidationProvider name="name" rules="required" v-slot="{valid, errors}">
                            <b-input-group class="mb-1" :prepend="$t('variable_language')">
                                <b-form-input v-model="form.name"
                                              :state="errors[0] ? false : null"/>
                            </b-input-group>
                            <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]" class="mb-2"/>
                        </ValidationProvider>
                        <ValidationProvider name="name_en" rules="required" v-slot="{valid, errors}">
                            <b-input-group prepend="EN">
                                <b-form-input v-model="form.name_en"
                                              :state="errors[0] ? false : null"/>
                            </b-input-group>
                            <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]"/>
                        </ValidationProvider>
                    </b-form-group>
                </b-col>
                <b-col md="6">
                    <ValidationProvider name="type" rules="required" v-slot="{ errors }">
                        <b-form-group :label="$t('type')">
                            <parameter-selectbox v-model="form.type" code="evaluation_types"
                                                 :validate-error="errors[0]" />
                        </b-form-group>
                    </ValidationProvider>
                </b-col>
                <b-col md="6">
                    <ValidationProvider name="status" rules="required" v-slot="{ valid, errors }">
                        <b-form-group :label="$t('status')">
                            <status-selectbox v-model="form.status" :state="errors[0] ? false : null" />
                            <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]" />
                        </b-form-group>
                    </ValidationProvider>
                </b-col>
                <b-col md="6">
                    <ValidationProvider name="max_class_average" rules="" v-slot="{ valid, errors }">
                        <b-form-group :label="$t('max_class_average')">
                            <b-form-input type="number"
                                          :min="0"
                                          :max="100"
                                          v-model="form.max_class_average">
                            </b-form-input>
                            <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]">
                            </b-form-invalid-feedback>
                        </b-form-group>
                    </ValidationProvider>
                </b-col>
                <b-col md="6">
                    <ValidationProvider name="min_score" rules="" v-slot="{ valid, errors }">
                        <b-form-group :label="$t('min_score')">
                            <b-form-input type="number"
                                          :min="0"
                                          :max="100"
                                          v-model="form.min_score">
                            </b-form-input>
                            <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]">
                            </b-form-invalid-feedback>
                        </b-form-group>
                    </ValidationProvider>
                </b-col>
                <b-col md="6">
                    <ValidationProvider name="max_score" rules="" v-slot="{ valid, errors }">
                        <b-form-group :label="$t('max_score')">
                            <b-form-input type="number"
                                          :min="0"
                                          :max="100"
                                          v-model="form.max_score">
                            </b-form-input>
                            <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]">
                            </b-form-invalid-feedback>
                        </b-form-group>
                    </ValidationProvider>
                </b-col>
                <b-col md="6">
                    <ValidationProvider name="min_number_of_participants" rules="" v-slot="{ valid, errors }">
                        <b-form-group :label="$t('min_number_of_participants')">
                            <b-form-input type="number"
                                          :min="0"
                                          v-model="form.min_number_of_participants">
                            </b-form-input>
                            <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]">
                            </b-form-invalid-feedback>
                        </b-form-group>
                    </ValidationProvider>
                </b-col>
                <b-col md="6">
                    <ValidationProvider name="min_relative_score" rules="" v-slot="{ valid, errors }">
                        <b-form-group :label="$t('min_relative_score')">
                            <b-form-input type="number"
                                          :min="0"
                                          :max="100"
                                          v-model="form.min_relative_score">
                            </b-form-input>
                            <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]">
                            </b-form-invalid-feedback>
                        </b-form-group>
                    </ValidationProvider>
                </b-col>
                <b-col md="6">
                    <ValidationProvider name="min_final_score" rules="" v-slot="{ valid, errors }">
                        <b-form-group :label="$t('min_final_score')">
                            <b-form-input type="number"
                                          :min="0"
                                          :max="100"
                                          v-model="form.min_final_score">
                            </b-form-input>
                            <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]">
                            </b-form-invalid-feedback>
                        </b-form-group>
                    </ValidationProvider>
                </b-col>
                <b-col md="6">
                    <ValidationProvider name="min_semester_score" rules="" v-slot="{ valid, errors }">
                        <b-form-group :label="$t('min_semester_score')">
                            <b-form-input type="number"
                                          :min="0"
                                          :max="100"
                                          v-model="form.min_semester_score">
                            </b-form-input>
                            <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]">
                            </b-form-invalid-feedback>
                        </b-form-group>
                    </ValidationProvider>
                </b-col>
                <b-col md="6">
                    <ValidationProvider name="t_score_multiplier" rules="" v-slot="{ valid, errors }">
                        <b-form-group :label="$t('t_score_multiplier')">
                            <b-form-input type="number"
                                          v-model="form.t_score_multiplier">
                            </b-form-input>
                            <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]">
                            </b-form-invalid-feedback>
                        </b-form-group>
                    </ValidationProvider>
                </b-col>
                <b-col md="6">
                    <ValidationProvider name="t_score_effect" rules="" v-slot="{ valid, errors }">
                        <b-form-group :label="$t('t_score_effect')">
                            <b-form-input type="number"
                                          v-model="form.t_score_effect">
                            </b-form-input>
                            <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]">
                            </b-form-invalid-feedback>
                        </b-form-group>
                    </ValidationProvider>

                </b-col>
            </b-row>
        </ValidationObserver>
        <div class="col-12 mt-3 d-flex">
            <b-button @click="updateForm" type="button" variant="primary" class="btn-lg mr-2">
                {{ $t('save').toLocaleUpperCase('tr-TR') }}
            </b-button>
        </div>
    </div>
</template>

<script>
    //Other
    import {ValidationProvider, ValidationObserver} from "vee-validate"
    //Service
    import EvaluationService from "@/services/EvaluationService";
    import StatusSelectbox from "@/components/interactive-fields/StatusSelectbox.vue";
    import EvaluationsSelectbox from "@/components/interactive-fields/EvaluationsSelectbox.vue";

    export default {
        components: {
            EvaluationsSelectbox,
            StatusSelectbox,
            ValidationProvider, ValidationObserver,
        },
        props: {
            formId: {
                type: Number,
            }
        },
        data() {
            return {
                formLoading: false,
                form: {
                    name: null,
                    name_en: null,
                    type: null,
                    status: null,
                    max_class_average: null,
                    min_score: null,
                    max_score: null,
                    min_number_of_participants: null,
                    min_relative_score: null,
                    min_final_score: null,
                    min_semester_score: null,
                    t_score_multiplier: null,
                    t_score_effect: null,
                    evaluation_id:null
                }
            }
        },
        watch: {
            formId: function (val) {
                this.get(val)
            }
        },
        async created() {
            await this.get(this.formId)
        },
        methods: {
            get(id) {
                this.formLoading = true;
                EvaluationService.get(id)
                               .then((response) => {
                                   this.form = response.data.data;
                                   this.formLoading = false;
                               })
                               .catch((error) => {
                                   if (error.data.message) {
                                       this.$toast.error(this.$t("api." + error.data.message));
                                   }
                               });
            },
            async updateForm() {
                const isValid = await this.$refs.formModalValidate.validate();
                if (isValid && this.formId) {
                    this.formLoading = true;
                    EvaluationService.update(this.formId, this.form)
                                   .then((response) => {
                                       this.$toast.success(this.$t("api." + response.data.message));
                                       this.$emit("updateFormSuccess")
                                   })
                                   .catch((error) => {
                                       this.showErrors(error, this.$refs.formModalValidate)
                                   }).finally(() => {
                        this.formLoading = false;
                    })
                }
            }
        }
    }
</script>
